import React, { useEffect } from "react";
import {
  MsalProvider,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import AppRoute from "./AppRoutes/router";
import Login from "./pages/Login";

const App = ({ instance }: any) => {
  return (
    <MsalProvider instance={instance}>
      <div>
        <AuthenticatedTemplate>
          <AppRoute />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>
      </div>
    </MsalProvider>
  );
};

export default App;
